module.exports = __webpack_public_path__ + "images/feature/20160901_01-828e91d6ae3e7513b83cb62085d7855a.png";